import config from '../../../config';
import {internalUrl} from '../../../lib/internalUrl';

// A person's Account lives in the console (console-api owns it), and Directory
// has no accounts screen, so the Account link opens there on the same stage.
// One builder for every place that links an Account, tagged for cross-property
// attribution like every other outbound internal link.
export const consoleAccountUrl = (accountId: string) =>
    internalUrl(`${config.platform.console}/accounts/${encodeURIComponent(accountId)}`, {
        campaign: 'account-link',
    });
